"use strict";

import dispatcher from "./../dispatcher";

import {Collection} from "vwa/flux";

import dataTypeStore from "./dataTypes";
import openedDetailsStore from "./openedDetails";

import {getSpeedBeforeIndex, createRouteFromSection} from "./../utils/vehicleActivity";

const vehicleActivityStore = new Collection({keyNames: ["vehicle"]});
export default vehicleActivityStore;

window.vehicleActivityStore = vehicleActivityStore;

function createStoreItemFromActivity(report, from, to) {
	return {
		vehicle:				report.options.carrier,
		from,
		to,
		summary:				report.result.summary,
		sections:				report.result.sections,
		routes:					report.result.sections.map(createRouteFromSection),
		selectedRoute:			{from: null, to: null},
		selectedPosition:		null,
		pinnedSections:			report.result.sections.map(s => true),
		highlightedSections:	report.result.sections.map(s => false),
		pending:				false
	};
}

function createStoreItemForPendingActivity(vehicleId, from, to) {
	return {
		vehicle:				vehicleId,
		from,
		to,
		summary:				null,
		sections:				[],
		routes:					[],
		selectedRoute:			null,
		selectedPosition:		null,
		pinnedSections:			null,
		highlightedSections:	null,
		pending:				true
	};
}

dispatcher.on('clearVehicleActivity', vehicleId => {
	vehicleActivityStore.remove([vehicleId]);
});

dispatcher.on('getVehicleActivity', (report, from, to) => {
	const prevActivity = vehicleActivityStore.get(report.options.carrier);
	if (prevActivity)
		vehicleActivityStore.update(report.options.carrier, createStoreItemFromActivity(report, from, to));
	else
		vehicleActivityStore.insert([createStoreItemFromActivity(report, from, to)]);
});

dispatcher.on("setPendingActivity", (vehicleId, from, to) => {
	const prevActivity = vehicleActivityStore.get(vehicleId);
	const storeItem = createStoreItemForPendingActivity(vehicleId, from, to);
	if(prevActivity){
		vehicleActivityStore.update(vehicleId, storeItem);
	}
	else{
		vehicleActivityStore.insert([storeItem]);
	}
});

dispatcher.on("highlightVehicleActivitySection", (vehicleId, sectionIndexes, value) => {
	const descriptor = vehicleActivityStore.get(vehicleId);
	if (!descriptor)
		return;
	
	sectionIndexes.forEach(sectionIndex => {
		if (descriptor.highlightedSections[sectionIndex] === undefined)
			return;
		descriptor.highlightedSections[sectionIndex] = value;
	});
	vehicleActivityStore.update(vehicleId, descriptor);
});

dispatcher.on("pinVehicleActivitySection", (vehicleId, sectionIndexes, value) => {
	const descriptor = vehicleActivityStore.get(vehicleId);
	if (!descriptor)
		return;
	
	sectionIndexes.forEach(sectionIndex => {
		if (descriptor.pinnedSections[sectionIndex] === undefined)
			return;
		descriptor.pinnedSections[sectionIndex] = value;
	});
	vehicleActivityStore.update(vehicleId, descriptor);
});

dispatcher.on("selectVehicleActivityRoute", (vehicleId, from = null, to = null) => {
	if (!vehicleId)
		return;
 	const descriptor = vehicleActivityStore.get(vehicleId);
	if(!descriptor){
		return;
	}
	descriptor.selectedRoute = {from, to};
	vehicleActivityStore.update(vehicleId, descriptor);
});

dispatcher.on("selectVehicleActivityPosition", (vehicleId, time) => {
 	const descriptor = vehicleActivityStore.get(vehicleId);
	if(!descriptor){
		return;
	}
	descriptor.selectedPosition = time;
	vehicleActivityStore.update(vehicleId, descriptor);
});

openedDetailsStore.on('remove', descriptors => {
	vehicleActivityStore.remove(descriptors.map(descriptor => descriptor.id));
});

dispatcher.on("logout", () => {
	vehicleActivityStore.set(null);
});


// WEBPACK FOOTER //
// ./src/store/vehicleActivities.js